// import { PlusCircle } from 'feather-icons-react/build/IconComponents';
import React, { useState, useEffect } from "react";
// import { Link } from 'react-router-dom';
import Select from 'react-select';
import Axios from "axios";
import { API_BASE_URL, DELETE_PO_PRODUCT, GET_PO_REQ_BY_ID, GET_VSTORE_PROD, INSERT_PURCHASE_REQ } from '../../../Config';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";

const EditPurchaseRequest = ({ tranObj }) => {
    console.log(tranObj)

    const [userDataSession, setUserDataSession] = useState([]);
    const [productsData, setProductsData] = useState([]);
    // const [storesData, setStoresData] = useState([]);
    // const [supplierData, setSupplierData] = useState([]);
    const [tranData, setTranData] = useState([]);
    const [firstData, setFirstData] = useState(null);
    const [formattedDate, setFormattedDate] = useState('');
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [poDetailsLoading, setPODetailsLoading] = useState(false);
    const [editNotes, setEditNotes] = useState("");

    // #region session userdetails
    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        // const productData = JSON.parse(sessionStorage.getItem('filteredDDLData_Products'));
        // const storesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Stores'));
        // const supplierData = JSON.parse(sessionStorage.getItem('filteredDDLData_Supplier'));

        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
            // setStoresData(storesData);
            // setSupplierData(supplierData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId && tranObj?.StoreId) {
            const requestData = {
                OrgId: `${userDataSession && userDataSession.OrgId}`,
                ProductId: 0,
                CategoryId: 0,
                BarCode: 0,
                IsForSale: 1,
                StoreId: tranObj.StoreId,
                UserId: userDataSession.UserId,
                Type: 1,
            };

            Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
                .then((response) => {
                    if (response.data.Status) {
                        setProductsData(response.data.ResultData);
                    } else {
                        console.error("Error fetching data:", response.data.Message);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                });
        }
    }, [userDataSession, tranObj.StoreId]);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId, tranObj.PurchaseId) {
            setPODetailsLoading(true);
            Axios.get(`${API_BASE_URL}${GET_PO_REQ_BY_ID}?OrgId=${userDataSession.OrgId}&PurchaseId=${tranObj.PurchaseId}`)
                .then((response) => {
                    setPODetailsLoading(false);
                    setTranData(response.data.ResultData);
                    setFirstData(response.data.ResultData[0]);
                    console.log(response.data.ResultData)
                })
                .catch((error) => {
                    setPODetailsLoading(false);
                    console.error("Error fetching stores:", error);
                });
        }
    }, [userDataSession, tranObj]);

    // const handleProductSelect = (selectedOption) => {
    //     const selectedProduct = productsData.find(prod => prod.Id === selectedOption.value);
    //     if (selectedProduct && !tranData.some(prod => prod.Id === selectedProduct.Id)) {
    //         setTranData([...tranData, {
    //             ProductId: selectedProduct.Id,
    //             ProductName: selectedProduct.ProductName,
    //             Quantity: 0,
    //             Notes: ''
    //         }]);
    //     }
    // };

    const handleProductSelect = (selectedOption) => {
        console.log("Products Data:", productsData);
        console.log("Selected option:", selectedOption);
    
        const selectedProduct = productsData.find(prod => prod.Id === selectedOption.value);
        console.log("Selected Product:", selectedProduct);
    
        if (!selectedProduct) {
            alert("Selected product is not valid.");
            return;
        }
    
        const isProductExisting = tranData.some(prod => prod.ProductId == selectedProduct.Id);
        console.log("Transaction Data:", tranData);
        console.log("Is Product Existing:", isProductExisting);
    
        if (isProductExisting) {
            alert("This product is already in the transaction list.");
            return;
        } else {
            setTranData([...tranData, {
                ProductId: selectedProduct.Id,
                ProductName: selectedProduct.ProductName,
                Quantity: 0,
                Notes: ''
            }]);
        }
    };
    

    const handleInputChange = (index, field, value) => {
        const updatedProductList = [...tranData];
        updatedProductList[index][field] = value;
        setTranData(updatedProductList);
    };

      // #region Delete
  const handleDelete = (item, index) => {
    if (!item.PurchaseDetailId) {
        setTranData((prevData) => prevData.filter((_, i) => i !== index));
        return;
    }
  
    const deleteData = {
        UserId: userDataSession.UserId,
        Id: item.PurchaseDetailId,
    };
    console.log(deleteData, 'deleteData deleteData');
  
    Axios.post(`${API_BASE_URL}${DELETE_PO_PRODUCT}`, deleteData)
        .then((response) => {
            if (response.data.ResultData[0].Status === 'Success') {
                console.log('Product deleted successfully:', response.data);
        
                setTranData((prevData) => prevData.filter((_, i) => i !== index));
            } else {
                console.error('Failed to delete product:', response.data.Message);
                alert('Failed to delete product from the database.');
            }
        })
        .catch((error) => {
            console.error('Error deleting product:', error);
            alert('Error occurred while deleting the product.');
        });
  };    


    const handleDateChange = (event) => {
        const selectedDate = event.target.value;
        setFormattedDate(selectedDate);
      
    };

    // #region Submit form func
    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log(tranObj, 'objjj');
        console.log(tranData, 'objjjtttt');
    
        const payload = {
            orgid: userDataSession.OrgId,
            userid: userDataSession.UserId,
            purchaserequest: {
                Id: tranObj.PurchaseId,
                StoreId: tranObj.StoreId,
                SupplierId: tranObj.SupplierId,
                RequestDate: tranObj.RequestDate,
                Notes: editNotes,
                Status: "DRAFT",
                // POStatus: "NULL"
            },
            productdetails: tranData.map(prod => ({
                detailid: prod.PurchaseDetailId ? prod.PurchaseDetailId : 0,
                ProductId: prod.ProductId,
                Quantity: prod.Quantity.toString(),
                UOM: prod.UOM,
                Comments: prod.Notes
            }))
        };
    
        console.log(payload, 'data sending to service...');
    
        try {
            setSubmitBtnLoading(true);
            const response = await fetch(`${API_BASE_URL}${INSERT_PURCHASE_REQ}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
    
            if (response.ok) {
                const data = await response.json(); 
                setSubmitBtnLoading(false);

                console.log(data, 'resposne from api');
    
                if (data[0].Success == 1) {
                    Swal.fire({
                        title: 'Success',
                        text: 'Purchase request updated successfully.',
                        icon: 'success',
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: 'Failed to update purchase request.',
                        icon: 'error',
                    });
                }
            } else {
                setSubmitBtnLoading(false);
                Swal.fire({
                    title: 'Error',
                    text: 'Failed to update purchase request. Please try again.',
                    icon: 'error',
                });
            }
        } catch (error) {
            setSubmitBtnLoading(false);
            console.error('Error:', error);
            Swal.fire({
                title: 'Error',
                text: 'An error occurred while processing your request.',
                icon: 'error',
            });
        }
    };

    useEffect(() => {
        // Parse and format PODate
        if (tranObj && tranObj.RequestDate) {
            const poDate = new Date(tranObj.RequestDate);
            const formatted = poDate.toISOString().split('T')[0];
            setFormattedDate(formatted);
        }
    }, [tranObj]);
    
    useEffect(() => {
        setEditNotes(firstData?.Notes);
    }, [firstData]);

    const customStyles = {
        control: (provided) => ({
          ...provided,
          minHeight: "2rem",
          height: "2.4rem",
        }),
        valueContainer: (provided) => ({
          ...provided,
          height: "1rem",
          padding: "0 6px",
        }),
        input: (provided) => ({
          ...provided,
          margin: "0",
        }),
      };

   
    return (
        <div>
            {/*edit popup */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightPREdit"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: "300px", maxWidth: "40%" }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Edit Purchase Request (PR-{firstData && firstData.AutoGenTransactionNo})</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <div className="car">
                        <div className="card-bod">
                            {/* <h4 className='ms-2'>(PR-{firstData && firstData.AutoGenTransactionNo})</h4> */}
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-4 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label className="form-label">Supplier</label>
                                            <div className="row">
                                                <div className="col-lg-12 col-sm-12 col-12">
                                                    <input
                                                        className='form-control'
                                                        value={tranObj.SupplierName}
                                                        style={{ cursor: 'not-allowed' }}
                                                        readOnly
                                                    />
                                                </div>

                                                {/* <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                                    <div className="add-icon">
                                                        <Link to="#" className="choose-add">
                                                            <PlusCircle className="plus" />
                                                        </Link>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label>Date</label>
                                            <div className="input-groupicon">
                                                <input 
                                                    className='form-control' 
                                                    type='date'
                                                    value={formattedDate}
                                                    onChange={handleDateChange}
                                                    style={{ cursor: 'not-allowed' }}
                                                        readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label>Store</label>
                                            <input  
                                                className='form-control'
                                                value={tranObj.StoreName}
                                                style={{ cursor: 'not-allowed' }}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label className="form-label">Notes</label>
                                            <input 
                                                type="text" 
                                                className='form-control'  
                                                placeholder='Enter notes'
                                                name='Notes'
                                                value={editNotes}
                                                onChange={(e) => setEditNotes(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label>Product </label>
                                            <div className="input-groupicon select-code">
                                                <Select 
                                                    className='select'
                                                    styles={customStyles}
                                                    options={productsData?.map((prod) => ({
                                                        value: prod.Id,
                                                        label: prod.ProductName,
                                                    }))}
                                                    onChange={handleProductSelect}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive no-pagination">
                                    <table className="table datanew">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Quantity</th>
                                                <th>Comment</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {poDetailsLoading ? (
                                                <tr>
                                                    <td colSpan="12" className='text-center'>Loading...</td>
                                                </tr>
                                                ) : (
                                                tranData && tranData?.map((prod, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{prod.ProductName}</td>
                                                        <td>
                                                            <input
                                                                type='number'
                                                                className='form-control'
                                                                style={{ width: '10rem' }}
                                                                value={prod.Quantity}
                                                                onChange={(e) => handleInputChange(index, 'Quantity', e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                placeholder='Enter comments'
                                                                value={prod.Notes}
                                                                onChange={(e) => handleInputChange(index, 'Notes', e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <button
                                                                className='btn btn-light'
                                                                type='button'
                                                                onClick={() => handleDelete(prod, index)}
                                                            >
                                                                <i className='fa-regular fa-trash-can text-danger fs-5'></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-lg-12 text-end">
                                        <button
                                            type="button"
                                            className="btn btn-cancel add-cancel me-3"
                                            data-bs-dismiss="offcanvas"
                                            aria-label="Close"
                                            disabled={submitBtnLoading}
                                        >
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-submit add-sale" disabled={submitBtnLoading}>
                                            {submitBtnLoading ? 'Submitting...' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                
    )
}

EditPurchaseRequest.propTypes = {
    tranObj: PropTypes.object.isRequired,
};

export default EditPurchaseRequest